export const CardStyle = {
  display: 'flex',
  width: '49%',
  marginBottom: '1rem',
};
export const CardActionStyle = {
  height: '20%',
  bottom: '.2em',
  position: 'absolute',
};

export const CardMediaStyle = {
  width: 151,
  minHeight: '15vh',
  margin: 2,
  borderRadius: '15px',
};

export const CardMain = {
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
};

export default {
  CardActionStyle,
  CardMain,
  CardMediaStyle,
  CardStyle,
};
